// Do not edit! This file is maintained automatically,
// please use 'npm run index' instead
import './article-info-init';
import './barcodes';
import './cash-units';
import './cashier-manager';
import './checkout-init';
import './customer-info-filter';
import './customer-info-filter-options';
import './discount-rules-manager';
import './drag-item';
import './end-of-shift';
import './eos-submit';
import './focus-streams';
import './get-data-model';
import './handle-template';
import './has-fiscal-printer';
import './is-fiscal-return';
import './is-fiscal-sale';
import './is-return';
import './last-transaction';
import './legacy-customer';
import './legacy-print';
import './load-article-info';
import './load-customer-info';
import './load-failure';
import './main-init';
import './message-manager';
import './navigate-to';
import './parser';
import './pay-plaza';
import './pay-plaza-requests';
import './pay-plaza-streams';
import './payment-types';
import './pin-provider';
import './pos';
import './pos-init';
import './pos-instance';
import './pos-reasons';
import './pos-state';
import './pos-ui-state';
import './print-coupon';
import './print-last-receipt';
import './print-receipt';
import './reprint-receipt';
import './route';
import './second-screen';
import './send-withdrawal';
import './sku';
import './transit-order-info';
import './transit-order-summary';
import './web-socket';
import './withdrawal-summary';
import './write-transaction';
import './pos-search';
import './pos-cashier';
